'use client';

import { css } from 'styled-components';

import type { ColorsType, ColorsTypeOld } from '../types/colors';

export const headerTheme = {
  headerBackground: '--header--header-background',
  mobileTitleBackground: '--header--mobile-title-background',
  zoomitTypography: '--header--zoomit-typography',
  zoomitLogo: '--header--zoomit-logo',
  menuLink: '--header--menu-link',
  menuPlusIcon: '--header--menu-plus-icon',
  searchIconBackground: '--header--search-icon-background',
  searchIcon: '--header--search-icon',
  mugIcon: '--header--mug-icon',
};

export const headerLight = (Colors: ColorsTypeOld | ColorsType) => css`
  ${headerTheme.headerBackground}: ${Colors.background2};
  ${headerTheme.mobileTitleBackground}: ${Colors.background1};
  ${headerTheme.zoomitTypography}: ${Colors.black3};
  ${headerTheme.zoomitLogo}: ${Colors.primary1};
  ${headerTheme.menuLink}: ${Colors.text};
  ${headerTheme.searchIconBackground}: ${Colors.black3};
  ${headerTheme.searchIcon}: ${Colors.white};
`;

export const headerDark = (Colors: ColorsTypeOld | ColorsType) => css`
  ${headerTheme.headerBackground}: ${Colors.background2};
  ${headerTheme.mobileTitleBackground}: ${Colors.grey6};
  ${headerTheme.zoomitTypography}: ${Colors.white};
  ${headerTheme.zoomitLogo}: ${Colors.white};
  ${headerTheme.menuLink}: ${Colors.text};
  ${headerTheme.searchIconBackground}: ${Colors.white};
  ${headerTheme.searchIcon}: ${Colors.black3};
`;

//
export const singleArticleTheme = {
  headerBackground: '--single-article--header-background',
};

export const singleArticleLight = (Colors: ColorsTypeOld | ColorsType) => css`
  ${singleArticleTheme.headerBackground}: ${Colors.background2};
`;

export const singleArticleDark = (Colors: ColorsTypeOld | ColorsType) => css`
  ${singleArticleTheme.headerBackground}: ${Colors.black1};
`;
